
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

interface FormActionsProps {
  loading: boolean;
}

const FormActions: React.FC<FormActionsProps> = ({ loading }) => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-end">
      <Button
        type="submit"
        disabled={loading}
        className="px-6 py-2 bg-brand-primary hover:bg-brand-primary/90 text-brand-primary-foreground rounded-md"
      >
        {loading ? t('production.form.saving') : t('production.form.createButton')}
      </Button>
    </div>
  );
};

export default FormActions;
